export const HEADER_SKIP_ERROR_INTERCEPTOR = 'skip-error-interceptor';
